import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { SurveysByTopicRow } from '../surveys-by-topic-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<SurveysByTopicRow> {

	return {
		rowName: { singular: 'Topic Response', plural: 'Topic Responses' },
		getRowKey: row => '' + row.accSessionTopicSurveyResponseId,
		stateKey: 'accelerator-surveys-by-topic-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
